import { useState, useCallback } from 'react';
import { removeMeFavoriteItemV1 } from '@/services/platform/api/me-—-favorites/me-—-favorites';

export interface UseRemoveFavoriteItemResult {
  isLoading: boolean;
  /** Removes an item from a favourite list. Returns true if the request succeeded. */
  removeItem: (listGuid: string, itemGuid: string) => Promise<boolean>;
}

export function useRemoveFavoriteItem(): UseRemoveFavoriteItemResult {
  const [isLoading, setIsLoading] = useState(false);

  const removeItem = useCallback(async (listGuid: string, itemGuid: string): Promise<boolean> => {
    setIsLoading(true);
    try {
      const response = await removeMeFavoriteItemV1(listGuid, itemGuid);
      return response.status === 204;
    } catch {
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { isLoading, removeItem };
}
